import angular from 'angular';

export default class DropdownRenderer {
  constructor(ctrl, name, templateData) {
    this.elem = ctrl.$element;
    this.name = name;
    this.ctrl = ctrl;
    this.componentName = ctrl.name;
    this.placeholderName = `akam-${this.componentName}-${this.name}-placeholder`;
    this.template = angular.element(templateData.template);
    this.customContent = this.getCustomContent();
    this.insertionNode = this.getInsertionNode(templateData);

    if (angular.isDefined(this.customContent)) {
      this.scope = ctrl.$scope.$parent.$new();
      this.scope[this.componentName] = ctrl;
    }
  }

  getInsertionNode(templateData) {
    //To avoid adding uneeded watches if the disabled property is not set
    //We use and ng-if in the template to avoid having the ng-class set
    //But that leaves 2 anchor tags to place any custom content. This function
    //Decides which of those 2 anchor tags is the correct one
    if (this.name === 'option' && !!this.ctrl.disabledProperty) {
      return angular.element(this.template[0].querySelectorAll(templateData.customSelector)[1]);
    } else {
      return angular.element(this.template[0].querySelector(templateData.customSelector));
    }
  }

  getCustomContent() {
    return this.elem.find(this.placeholderName).remove().html() || undefined;
  }

  render() {
    if (angular.isDefined(this.customContent) && angular.isDefined(this.insertionNode)) {
      if (angular.element(this.insertionNode).hasClass('dropdown-item-link')) {
        angular.element(this.insertionNode).addClass('akam-dropdown-custom-content');
      }
      this.insertionNode.html(this.customContent);
    }

    let compiledTemplate;

    if (angular.isDefined(this.scope)) {
      compiledTemplate = this.ctrl.$compile(this.template)(this.scope);
    } else {
      compiledTemplate = this.ctrl.$compile(this.template)(this.ctrl.$scope);
    }

    return compiledTemplate;
  }
}
